import {UI} from "../../../../../stem-core/src/ui/UIBase";
import {styleRule, StyleSheet} from "../../../../../stem-core/src/ui/Style";

import {Messages} from "../../../../Messages";
import {InfoIcon} from "../../../../../core/ui/SVGElements.jsx";
import {AutoReloadPopup} from "./AutoReloadPopup";
import {UserPreferencesStore} from "../../../../State";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {apiUpdatePreferences} from "../../../../../client/state/UserPreferencesStore";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw";
import {Direction} from "../../../../../stem-core/src/ui/Constants";
import {wrapInSpinner} from "../../../../../core/ui/LoadingSpinner.jsx";
import {ToggleButton} from "../../../../../core/ui/input/ToggleInput.jsx";


class AutoReloadStyle extends StyleSheet {
    @styleRule
    container = {
        display: "flex",
        justifyContent: "space-between",
    }

    @styleRule
    autoReloadInfo = {
        position: "absolute",
        display: "inline-block",
        marginLeft: 6,
        transform: "translateY(2px)",
        cursor: "pointer",
        ":hover g": {
            fill: this.themeProps.WALLET_3,
        }
    };
}

@registerStyle(AutoReloadStyle)
@autoredraw(UserPreferencesStore)
export class AutoReload extends UI.Element {
    getPreferences() {
        return UserPreferencesStore.getPreferences();
    }

    render() {
        const {styleSheet} = this;
        const {autoTopUpEnabled} = this.getPreferences();

        return [
            <span>
                {Messages.autoReload}
                <InfoIcon className={styleSheet.autoReloadInfo} ref="infoIcon" />
            </span>,
            <ToggleButton
                testId="walletAutoReloadToggle"
                active={autoTopUpEnabled}
                onChange={(active) => this.updateAutoReload(active)}
            />
        ];
    }

    @wrapInSpinner
    async updateAutoReload(autoReload) {
        const preferences = this.getPreferences();
        preferences.autoTopUpEnabled = autoReload;

        await apiUpdatePreferences(preferences.getFields());
    }

    onMount() {
        // TODO @cleanup we have a canonical way to make info elements, use that
        this.infoIcon.addNodeListener("mouseenter", () => {
            AutoReloadPopup.show({
                anchor: this.infoIcon,
                hideOnMouseLeave: true,
                toggleOnSameAnchor: true,
                direction: Direction.DOWN
            });
        });
    }
}
